import { AsyncPipe } from '@angular/common';
import { ApplicationRef, Component, EnvironmentInjector, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { defineActionButtonRenderer } from '@shared/components/action-button-renderer/define-action-button-renderer';
import { DialogHostComponent } from '@shared/components/dialog-host/dialog-host.component';
import { OAuthService } from '@shared/service/auth/o-auth.service';
import { UserFacade } from '@store/user/user.facade';

import { LanguageService } from './i18n/language.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass'],
  imports: [RouterOutlet, AsyncPipe, DialogHostComponent]
})
export class AppComponent implements OnInit {
  private readonly oAuthService = inject(OAuthService);
  private readonly applicationRef = inject(ApplicationRef);
  private readonly envInjector = inject(EnvironmentInjector);
  private readonly languageService = inject(LanguageService);
  protected readonly userFacade = inject(UserFacade);

  public ngOnInit(): void {
    this.oAuthService.initializeAuth();
    this.languageService.initLanguage();

    // Register the custom web component
    defineActionButtonRenderer(this.envInjector, this.applicationRef);

    // Append the snackbar component to the body
    document.body.append(document.createElement('cw-snackbar'));
  }
}
